import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall, widthMedium } = breakpoints;
const S = {};

S.Billing = styled.main`
  label: Billing;

  text-align: center;

  @media (${widthMedium}) {
    text-align: initial;
  }
`;

S.ContentWrapper = styled.section`
  label: ContentWrapper;

  display: flex;
  flex-direction: column;

  @media (${widthSmall}) {
    max-width: 100%;
    align-items: center;
  }

  @media (${widthMedium}) {
    align-items: flex-start;
  }
`;

S.Title = styled.h1`
  label: Title;

  @media (${widthSmall}) {
    max-width: 25rem;
  }

  @media (${widthMedium}) {
    max-width: 39.1875rem;
  }
`;

S.Subtitle = styled.h3`
  label: Subtitle;

  margin-top: 0.75rem;
  max-width: 43.75rem;

  &:first-of-type {
    margin-top: 1rem;
  }
`;

S.ButtonHolder = styled.div`
  label: ButtonHolder;

  display: flex;
  flex-direction: column;
  max-width: 25rem;
  width: 100%;
  margin: 0 auto;
  margin-top: 1.5rem;

  @media (${widthSmall}) {
    display: block;
    max-width: none;
    margin-top: 2rem;
  }

  @media (${widthMedium}) {
    margin-top: 3rem;
  }
`;

export default S;
